/* Broach Photo — theme behaviour. No dependencies. */
(function () {
  'use strict';

  function reveals() {
    var els = [].slice.call(document.querySelectorAll('[data-reveal]'));
    if (!els.length) return;
    function check() {
      var h = window.innerHeight;
      els = els.filter(function (el) {
        if (el.getBoundingClientRect().top < h * 0.94) { el.classList.add('is-in'); return false; }
        return true;
      });
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* Justified image bands: width proportional to each image's aspect ratio,
     so a row of mixed orientations shares one height, uncropped. */
  function bands() {
    document.querySelectorAll('.band__cell img').forEach(function (img) {
      if (img.closest('.page-concept-portraits .band')) return;
      function apply() {
        if (!img.naturalWidth) return;
        var r = img.naturalWidth / img.naturalHeight;
        img.closest('.band__cell').style.flex = r + ' 1 ' + Math.round(r * 180) + 'px';
      }
      if (img.complete) { apply(); } else { img.addEventListener('load', apply); }
    });
  }

  function hero() {
    document.querySelectorAll('[data-hero]').forEach(function (root) {
      var slides = root.querySelectorAll('.hero__slide');
      var dots = root.querySelectorAll('.hero__dot');
      if (slides.length < 2) return;
      var i = 0, timer;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      function start() {
        clearInterval(timer);
        timer = setInterval(function () { show(i + 1); }, (Number(root.dataset.hero) || 5) * 1000);
      }
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { show(k); start(); });
      });
      show(0);
      start();
    });
  }

  function conceptComparisons() {
    document.querySelectorAll('[data-concept-comparison]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      var range = root.querySelector('[data-comparison-range]');
      var final = root.querySelector('[data-comparison-final]');
      var handle = root.querySelector('[data-comparison-handle]');
      if (!range || !final || !handle) return;
      function sync() {
        var value = Number(range.value);
        final.style.clipPath = 'inset(0 0 0 ' + value + '%)';
        handle.style.left = value + '%';
      }
      range.addEventListener('input', sync);
      sync();
    });
  }

  function bookingCalendars() {
    document.querySelectorAll('[data-booking-calendar]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      var monthsEl = root.querySelector('[data-calendar-months]');
      var rangeEl = root.querySelector('[data-calendar-range]');
      var prev = root.querySelector('[data-calendar-prev]');
      var next = root.querySelector('[data-calendar-next]');
      var selectedInput = root.querySelector('[data-selected-date-input]');
      var selectedLabel = root.querySelector('[data-selected-date-label]');
      var submit = root.querySelector('[data-booking-submit]');
      var service = root.querySelector('[data-booking-service]');
      var variantInput = root.querySelector('[data-booking-variant-input]');
      var depositLabel = root.querySelector('[data-booking-deposit]');
      var paymentForm = root.querySelector('[data-booking-payment-form]');
      var bookedScript = root.querySelector('[data-booked-dates]');
      var bookedDatesUrl = root.dataset.bookedDatesUrl;
      var today = new Date();
      today.setHours(0, 0, 0, 0);

      var bookedDates = [];
      try { bookedDates = JSON.parse(bookedScript.textContent || '[]'); } catch (e) {}
      function addBookedDate(set, date) {
        date = String(date || '').trim();
        if (date) set[date] = true;
      }
      function mergeBookedDates(dates) {
        if (!Array.isArray(dates)) return;
        dates.forEach(function (date) {
          if (typeof date === 'string') addBookedDate(booked, date);
          if (date && typeof date === 'object') addBookedDate(booked, date.date || date.start || date.day);
        });
      }
      function loadBookedDates(url) {
        var callbackName = 'broachBookedDates' + Math.random().toString(36).slice(2);
        var separator = url.indexOf('?') === -1 ? '?' : '&';
        var script = document.createElement('script');
        script.src = url + separator + 'callback=' + callbackName;
        script.async = true;

        window[callbackName] = function (data) {
          mergeBookedDates(Array.isArray(data) ? data : data && data.bookedDates);
          render();
          delete window[callbackName];
          script.remove();
        };

        script.onerror = function () {
          delete window[callbackName];
          script.remove();
        };

        document.head.appendChild(script);
      }
      var booked = bookedDates.reduce(function (set, date) {
        addBookedDate(set, date);
        return set;
      }, {});

      var start = new Date(today.getFullYear(), today.getMonth(), 1);
      var offset = 0;
      var windowSize = 3;
      var maxOffset = 15;

      function pad(n) { return String(n).padStart(2, '0'); }
      function iso(date) { return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()); }
      function label(date) {
        return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
      }
      function monthLabel(date) {
        return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
      }
      function addMonths(date, amount) {
        return new Date(date.getFullYear(), date.getMonth() + amount, 1);
      }

      function selectDate(date) {
        var value = iso(date);
        selectedInput.value = value;
        selectedLabel.textContent = label(date);
        submit.disabled = false;
        root.querySelectorAll('.booking-day').forEach(function (day) {
          day.classList.toggle('is-selected', day.dataset.date === value);
        });
      }

      function syncService() {
        if (!service || !variantInput) return;
        var option = service.options[service.selectedIndex];
        variantInput.value = option.dataset.variant || variantInput.value;
        if (depositLabel) depositLabel.textContent = option.dataset.deposit || '';
      }

      function render() {
        monthsEl.innerHTML = '';
        var first = addMonths(start, offset);
        var last = addMonths(start, offset + windowSize - 1);
        rangeEl.textContent = monthLabel(first) + ' - ' + monthLabel(last);
        prev.disabled = offset <= 0;
        next.disabled = offset >= maxOffset;

        for (var i = 0; i < windowSize; i++) {
          var month = addMonths(start, offset + i);
          var firstDay = new Date(month.getFullYear(), month.getMonth(), 1);
          var lastDay = new Date(month.getFullYear(), month.getMonth() + 1, 0);
          var section = document.createElement('section');
          section.className = 'booking-month';
          section.innerHTML = '<h3>' + monthLabel(month) + '</h3><div class="booking-month__week"><span>Sun</span><span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span></div>';
          var grid = document.createElement('div');
          grid.className = 'booking-month__grid';

          for (var empty = 0; empty < firstDay.getDay(); empty++) {
            var spacer = document.createElement('button');
            spacer.type = 'button';
            spacer.className = 'booking-day is-empty';
            spacer.tabIndex = -1;
            grid.appendChild(spacer);
          }

          for (var day = 1; day <= lastDay.getDate(); day++) {
            var date = new Date(month.getFullYear(), month.getMonth(), day);
            var value = iso(date);
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'booking-day';
            button.textContent = day;
            button.dataset.date = value;
            button.setAttribute('aria-label', label(date));

            if (date < today || booked[value]) {
              button.disabled = true;
              if (booked[value]) {
                button.classList.add('is-booked');
                button.textContent = 'Booked';
                button.setAttribute('aria-label', label(date) + ' booked');
              }
            } else {
              button.addEventListener('click', function () { selectDate(new Date(this.dataset.date + 'T00:00:00')); });
            }
            grid.appendChild(button);
          }

          section.appendChild(grid);
          monthsEl.appendChild(section);
        }
      }

      prev.addEventListener('click', function () { offset = Math.max(0, offset - windowSize); render(); });
      next.addEventListener('click', function () { offset = Math.min(maxOffset, offset + windowSize); render(); });
      if (service) service.addEventListener('change', syncService);
      if (paymentForm) {
        paymentForm.addEventListener('submit', function (event) {
          if (!paymentForm.checkValidity()) {
            event.preventDefault();
            paymentForm.reportValidity();
          }
        });
      }
      syncService();
      render();
      if (bookedDatesUrl) {
        loadBookedDates(bookedDatesUrl);
      }
    });
  }

  function init() { reveals(); bands(); hero(); conceptComparisons(); bookingCalendars(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
